export class FolderUnlockResponseNotification {
	public viewId: number;
	public folderId: string;
	public folderName: string;
	public userName: string;
	public accept: boolean;

	public static fromJson(other: any): FolderUnlockResponseNotification {
		const instance = new FolderUnlockResponseNotification();
		instance.folderId = other.FolderId;
		instance.viewId = other.ViewId;
		instance.folderName = other.FolderName;
		instance.userName = other.UserDisplayName;
		instance.accept = other.Accept;
		return instance;
	}
}
